module.exports = __webpack_public_path__ + "static/media/ic-service-large.cf5f8d44.svg";